if (!customElements.get('tolin-promotion-popup')) {
  let popupHasShown = false;

  class TolinPromotionPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('[data-popup-close]');

      if (!this.dialog || popupHasShown) return;

      this.closeButton?.addEventListener('click', () => this.dismiss());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dismiss();
      });

      const delay = Number.parseInt(this.dataset.delay, 10) || 3000;
      this.openTimer = window.setTimeout(() => {
        if (!this.dialog.isConnected || this.dialog.open || popupHasShown) return;

        this.dialog.showModal();
        popupHasShown = true;
      }, delay);
    }

    disconnectedCallback() {
      window.clearTimeout(this.openTimer);
    }

    dismiss() {
      this.dialog.close();
    }
  }

  customElements.define('tolin-promotion-popup', TolinPromotionPopup);
}
